import * as i0 from '@angular/core';
import { input, Component, inject, computed, output, signal, effect, Optional, Self, HostListener, Inject } from '@angular/core';
import { GhostStateFragmentDirective, COMPONENT_STATE } from '@futura/futura-ui/ghost';
import * as i1$1 from '@jsverse/transloco';
import { TranslocoPipe, TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { TooltipDirective } from '@futura/futura-ui/tooltip';
import { NgClass, NgTemplateOutlet, AsyncPipe, DecimalPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { AnalyticsButtonDirective } from '@futura/futura-ui/analytics';
import { getTranslateModel, getIconInfo } from '@futura/futura-ui/core';
import { of } from 'rxjs';
import { MatMenuTrigger, MatMenu, MatMenuContent } from '@angular/material/menu';
import { UrlParamsService, makeAttributes, ANALYTICS_PROVIDER } from '@futura/futura-ui';
import * as i1 from '@angular/forms';
import { EditableDirective } from '@futura/futura-ui/editable';
import { PodiumIconComponent } from '@futura/futura-ui/podium-icon';
const _c0 = ["*"];
const _c1 = (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) => ({
  "no-border": a0,
  accent: a1,
  "fut-btn-outline": a2,
  "fut-btn-primary": a3,
  "fut-btn-secondary": a4,
  "fut-btn-tertiary": a5,
  "fut-btn-link": a6,
  "fut-btn-sm": a7,
  "fut-btn-md": a8,
  "fut-btn-lg": a9
});
function ActionIconComponent_button_0_ng_container_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainer(0);
  }
}
function ActionIconComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 2);
    i0.ɵɵpipe(1, "transloco");
    i0.ɵɵtemplate(2, ActionIconComponent_button_0_ng_container_2_Template, 1, 0, "ng-container", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const iconContent_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("eventTitle", ctx_r0.eventTitle())("eventType", "icon")("eventAction", ctx_r0.eventAction())("eventTarget", ctx_r0.eventTarget())("eventAttributes", ctx_r0.eventAttributes())("futTooltip", i0.ɵɵpipeBind1(1, 11, ctx_r0.tooltip() || ""))("hideTooltip", !ctx_r0.tooltip())("ngClass", i0.ɵɵpureFunctionV(13, _c1, [ctx_r0.hideBorder(), ctx_r0.buttonType() === "accent", ctx_r0.buttonType() === "default", ctx_r0.buttonType() === "primary", ctx_r0.buttonType() === "secondary", ctx_r0.buttonType() === "tertiary", ctx_r0.buttonType() === "link", ctx_r0.size() === "sm", ctx_r0.size() === "md", ctx_r0.size() === "lg"]))("position", ctx_r0.position())("tooltipType", ctx_r0.tooltipType());
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", iconContent_r2);
  }
}
function ActionIconComponent_ng_template_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 4);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("fontSet", ctx_r0.fontSet());
  }
}
function ButtonMenuContentComponent_Conditional_1_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx);
  }
}
function ButtonMenuContentComponent_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "header", 1)(1, "h3", 2);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, ButtonMenuContentComponent_Conditional_1_Conditional_3_Template, 2, 1, "mat-icon");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_3_0 = ctx_r0.titleIcon()) ? 3 : -1, tmp_3_0);
  }
}
const _c2 = a0 => ({
  "type-danger": a0
});
function ButtonMenuElementComponent_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 1);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r1 = ctx;
    i0.ɵɵproperty("fontSet", icon_r1.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(icon_r1.icon);
  }
}
function ButtonMenuElementComponent_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "img", 2);
  }
  if (rf & 2) {
    i0.ɵɵproperty("src", ctx, i0.ɵɵsanitizeUrl);
  }
}
function ButtonMenuElementComponent_Conditional_4_div_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const translate_r2 = i0.ɵɵnextContext().$implicit;
    const elementLabel_r3 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", translate_r2(elementLabel_r3.text, elementLabel_r3.translateArgs), " ");
  }
}
function ButtonMenuElementComponent_Conditional_4_div_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const elementLabel_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", elementLabel_r3.text, " ");
  }
}
function ButtonMenuElementComponent_Conditional_4_div_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div");
    i0.ɵɵtemplate(1, ButtonMenuElementComponent_Conditional_4_div_0_Conditional_1_Template, 1, 1)(2, ButtonMenuElementComponent_Conditional_4_div_0_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const elementLabel_r3 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(elementLabel_r3.translate ? 1 : 2);
  }
}
function ButtonMenuElementComponent_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonMenuElementComponent_Conditional_4_div_0_Template, 3, 1, "div", 3);
  }
  if (rf & 2) {
    i0.ɵɵproperty("translocoScope", ctx.scope);
  }
}
const _c3 = a0 => ({
  open: a0
});
const _c4 = (a0, a1) => ({
  icon: a0,
  fontSet: a1
});
function ButtonComboComponent_Conditional_0_ng_container_1_Conditional_1_span_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const translate_r3 = i0.ɵɵnextContext().$implicit;
    const label_r4 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", translate_r3(label_r4.text, label_r4.translateArgs), " ");
  }
}
function ButtonComboComponent_Conditional_0_ng_container_1_Conditional_1_span_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const label_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", label_r4.text, " ");
  }
}
function ButtonComboComponent_Conditional_0_ng_container_1_Conditional_1_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtemplate(1, ButtonComboComponent_Conditional_0_ng_container_1_Conditional_1_span_0_Conditional_1_Template, 1, 1)(2, ButtonComboComponent_Conditional_0_ng_container_1_Conditional_1_span_0_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const label_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(label_r4.translate ? 1 : 2);
  }
}
function ButtonComboComponent_Conditional_0_ng_container_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonComboComponent_Conditional_0_ng_container_1_Conditional_1_span_0_Template, 3, 1, "span", 6);
  }
  if (rf & 2) {
    i0.ɵɵproperty("translocoScope", ctx.scope);
  }
}
function ButtonComboComponent_Conditional_0_ng_container_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, ButtonComboComponent_Conditional_0_ng_container_1_Conditional_1_Template, 1, 1, "span", 4);
    i0.ɵɵelementStart(2, "mat-icon", 5);
    i0.ɵɵtext(3, "arrow_drop_down ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    let tmp_4_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_4_0 = ctx_r1.labelFixed() || ctx_r1.labelSelected()) ? 1 : -1, tmp_4_0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c3, ctx_r1.menuOpened()));
  }
}
function ButtonComboComponent_Conditional_0_ng_template_4_For_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fut-button-menu-element", 8);
    i0.ɵɵlistener("click", function ButtonComboComponent_Conditional_0_ng_template_4_For_2_Template_fut_button_menu_element_click_0_listener() {
      const item_r6 = i0.ɵɵrestoreView(_r5).$implicit;
      const ctx_r1 = i0.ɵɵnextContext(3);
      return i0.ɵɵresetView(ctx_r1.selectItem(item_r6));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const item_r6 = ctx.$implicit;
    i0.ɵɵproperty("elementLabel", item_r6.label)("eventAction", item_r6.action)("eventTarget", item_r6.target)("eventAttributes", item_r6.attributes)("iconInfo", i0.ɵɵpureFunction2(5, _c4, (item_r6 == null ? null : item_r6.icon) || "", (item_r6 == null ? null : item_r6.fontSet) || "material-symbols-outlined"));
  }
}
function ButtonComboComponent_Conditional_0_ng_template_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fut-button-menu-content");
    i0.ɵɵrepeaterCreate(1, ButtonComboComponent_Conditional_0_ng_template_4_For_2_Template, 1, 8, "fut-button-menu-element", 7, i0.ɵɵrepeaterTrackByIdentity);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const items_r7 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵrepeater(items_r7);
  }
}
function ButtonComboComponent_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("menuOpened", function ButtonComboComponent_Conditional_0_Template_button_menuOpened_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.menuOpened.set(true));
    })("menuClosed", function ButtonComboComponent_Conditional_0_Template_button_menuClosed_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const ctx_r1 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r1.menuOpened.set(false));
    });
    i0.ɵɵtemplate(1, ButtonComboComponent_Conditional_0_ng_container_1_Template, 4, 4, "ng-container", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "mat-menu", null, 0);
    i0.ɵɵtemplate(4, ButtonComboComponent_Conditional_0_ng_template_4_Template, 3, 0, "ng-template", 3);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const menu_r8 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", ctx_r1.buttonClasses())("matMenuTriggerFor", menu_r8);
    i0.ɵɵadvance();
    i0.ɵɵproperty("futGhostStateFragment", ctx_r1.state())("futGhostStateFragmentTextMinChar", 4)("futGhostStateFragmentTextMaxChar", 8);
  }
}
function ButtonMenuComponent_fut_action_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fut-action-icon", 3);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    const menu_r2 = i0.ɵɵreference(2);
    i0.ɵɵproperty("matMenuTriggerFor", menu_r2)("position", ctx_r0.position())("tooltipType", ctx_r0.tooltipType())("tooltip", ctx_r0.tooltip())("hideBorder", ctx_r0.buttonType() === "default")("buttonType", ctx_r0.buttonType())("size", ctx_r0.size());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r0.buttonIcon(), "\n");
  }
}
function ButtonMenuComponent_ng_template_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "fut-button-menu-content", 4);
    i0.ɵɵprojection(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵproperty("menuTitle", ctx_r0.menuTitle())("titleIcon", ctx_r0.titleIcon());
  }
}
const _c5 = (a0, a1, a2, a3, a4) => ({
  "variant-std": a0,
  "variant-light": a1,
  "variant-optional": a2,
  "variant-dark": a3,
  "with-ghost": a4
});
function ButtonTileComponent_button_0_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 8)(1, "mat-icon", 7);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const icon_r1 = ctx;
    i0.ɵɵadvance();
    i0.ɵɵproperty("fontSet", icon_r1.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", icon_r1.icon, " ");
  }
}
function ButtonTileComponent_button_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonTileComponent_button_0_Conditional_2_Conditional_0_Template, 3, 2, "div", 8);
  }
  if (rf & 2) {
    let tmp_3_0;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional((tmp_3_0 = ctx_r1.internalSecondaryIcon()) ? 0 : -1, tmp_3_0);
  }
}
function ButtonTileComponent_button_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵelement(1, "img", 9);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("src", ctx_r1.imgSrc(), i0.ɵɵsanitizeUrl);
  }
}
function ButtonTileComponent_button_0_Conditional_5_Conditional_0_h3_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 12);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const title_r3 = i0.ɵɵnextContext(3);
    const translate_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("futEditable", title_r3.text);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(translate_r4(title_r3.text));
  }
}
function ButtonTileComponent_button_0_Conditional_5_Conditional_0_h3_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 13);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const title_r3 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(title_r3.text);
  }
}
function ButtonTileComponent_button_0_Conditional_5_Conditional_0_h3_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "h3", 10);
    i0.ɵɵtemplate(1, ButtonTileComponent_button_0_Conditional_5_Conditional_0_h3_0_Conditional_1_Template, 2, 2, "span", 12)(2, ButtonTileComponent_button_0_Conditional_5_Conditional_0_h3_0_Conditional_2_Template, 2, 1, "span", 13);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const title_r3 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵconditional(title_r3.translate ? 1 : 2);
  }
}
function ButtonTileComponent_button_0_Conditional_5_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonTileComponent_button_0_Conditional_5_Conditional_0_h3_0_Template, 3, 1, "h3", 11);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("futGhostStateFragment", ctx_r1.state())("futGhostStateFragmentTextMinChar", 5)("futGhostStateFragmentTextMaxChar", 8);
  }
}
function ButtonTileComponent_button_0_Conditional_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonTileComponent_button_0_Conditional_5_Conditional_0_Template, 1, 3, "h3", 10);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx.text || ctx_r1.state() !== "NONE" ? 0 : -1);
  }
}
function ButtonTileComponent_button_0_Conditional_6_Conditional_0_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 14);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const subtitle_r5 = i0.ɵɵnextContext(2);
    const translate_r4 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵproperty("futEditable", subtitle_r5.text);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(translate_r4(subtitle_r5.text));
  }
}
function ButtonTileComponent_button_0_Conditional_6_Conditional_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small");
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const subtitle_r5 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(subtitle_r5.text);
  }
}
function ButtonTileComponent_button_0_Conditional_6_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonTileComponent_button_0_Conditional_6_Conditional_0_Conditional_0_Template, 2, 2, "small", 14)(1, ButtonTileComponent_button_0_Conditional_6_Conditional_0_Conditional_1_Template, 2, 1, "small");
  }
  if (rf & 2) {
    const subtitle_r5 = i0.ɵɵnextContext();
    i0.ɵɵconditional(subtitle_r5.translate ? 0 : 1);
  }
}
function ButtonTileComponent_button_0_Conditional_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonTileComponent_button_0_Conditional_6_Conditional_0_Template, 2, 1);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx.text && ctx_r1.state() === "NONE" ? 0 : -1);
  }
}
function ButtonTileComponent_button_0_Conditional_7_Conditional_4_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 16);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("/", i0.ɵɵpipeBind1(2, 1, ctx_r1.total()), "");
  }
}
function ButtonTileComponent_button_0_Conditional_7_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 5)(1, "div", 15);
    i0.ɵɵtext(2);
    i0.ɵɵpipe(3, "number");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, ButtonTileComponent_button_0_Conditional_7_Conditional_4_Template, 3, 3, "small", 16);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind1(3, 2, ctx_r1.partial()));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.total() != null ? 4 : -1);
  }
}
function ButtonTileComponent_button_0_Conditional_8_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵprojection(0);
  }
}
function ButtonTileComponent_button_0_Conditional_10_mat_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 7);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r6 = i0.ɵɵnextContext();
    i0.ɵɵproperty("fontSet", icon_r6.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", icon_r6.icon, " ");
  }
}
function ButtonTileComponent_button_0_Conditional_10_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonTileComponent_button_0_Conditional_10_mat_icon_0_Template, 2, 2, "mat-icon", 17);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("futGhostStateFragment", ctx_r1.state())("futGhostStateFragmentText", "--");
  }
}
function ButtonTileComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 1)(1, "div", 2);
    i0.ɵɵtemplate(2, ButtonTileComponent_button_0_Conditional_2_Template, 1, 1)(3, ButtonTileComponent_button_0_Conditional_3_Template, 2, 1, "div", 3);
    i0.ɵɵelementStart(4, "div", 4);
    i0.ɵɵtemplate(5, ButtonTileComponent_button_0_Conditional_5_Template, 1, 1)(6, ButtonTileComponent_button_0_Conditional_6_Template, 1, 1)(7, ButtonTileComponent_button_0_Conditional_7_Template, 5, 4, "div", 5);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(8, ButtonTileComponent_button_0_Conditional_8_Template, 1, 0);
    i0.ɵɵelementStart(9, "div", 6);
    i0.ɵɵtemplate(10, ButtonTileComponent_button_0_Conditional_10_Template, 1, 2, "mat-icon", 7);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    let tmp_5_0;
    let tmp_6_0;
    let tmp_9_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(8, _c5, ctx_r1.variant() === "std", ctx_r1.variant() === "light", ctx_r1.variant() === "optional", ctx_r1.variant() === "dark", ctx_r1.state() !== "NONE"));
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.secondaryIcon() && ctx_r1.state() === "NONE" ? 2 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.imgSrc() && ctx_r1.state() === "NONE" ? 3 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_5_0 = ctx_r1.title()) ? 5 : -1, tmp_5_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_6_0 = ctx_r1.subtitle()) ? 6 : -1, tmp_6_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.partial() != null && ctx_r1.state() === "NONE" ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.state() === "NONE" ? 8 : -1);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional((tmp_9_0 = ctx_r1.internalPrimaryIcon()) ? 10 : -1, tmp_9_0);
  }
}
const _c6 = (a0, a1, a2, a3, a4) => ({
  "fut-btn-primary": a0,
  "fut-btn-secondary": a1,
  "fut-btn-tertiary": a2,
  "fut-btn-accent": a3,
  "fut-btn-link": a4
});
const _c7 = a0 => ({
  "fut-text-secondary-900": a0
});
function ButtonIconComponent_button_0_Conditional_1_mat_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("fontSet", icon_r1.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(icon_r1.icon);
  }
}
function ButtonIconComponent_button_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonIconComponent_button_0_Conditional_1_mat_icon_0_Template, 2, 2, "mat-icon", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("futGhostStateFragment", ctx_r1.state())("futGhostStateFragmentTextMaxChar", 2);
  }
}
function ButtonIconComponent_button_0_Conditional_2_Conditional_0_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 4);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const buttonTitle_r3 = i0.ɵɵnextContext(2);
    const translate_r4 = i0.ɵɵnextContext().$implicit;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(3, _c7, ctx_r1.variant() === "link-secondary"))("futEditable", buttonTitle_r3);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", translate_r4(buttonTitle_r3), "");
  }
}
function ButtonIconComponent_button_0_Conditional_2_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonIconComponent_button_0_Conditional_2_Conditional_0_span_0_Template, 2, 5, "span", 6);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("futGhostStateFragment", ctx_r1.state())("futGhostStateFragmentTextMinChar", 5)("futGhostStateFragmentTextMaxChar", 5);
  }
}
function ButtonIconComponent_button_0_Conditional_2_Conditional_1_span_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 5);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const buttonTitle_r3 = i0.ɵɵnextContext(2);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(2, _c7, ctx_r1.variant() === "link-secondary"));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", buttonTitle_r3, " ");
  }
}
function ButtonIconComponent_button_0_Conditional_2_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonIconComponent_button_0_Conditional_2_Conditional_1_span_0_Template, 2, 4, "span", 7);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("futGhostStateFragment", ctx_r1.state())("futGhostStateFragmentTextMinChar", 5)("futGhostStateFragmentTextMaxChar", 5);
  }
}
function ButtonIconComponent_button_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonIconComponent_button_0_Conditional_2_Conditional_0_Template, 1, 3, "span", 4)(1, ButtonIconComponent_button_0_Conditional_2_Conditional_1_Template, 1, 3, "span", 5);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵconditional(ctx_r1.translateTitle() ? 0 : 1);
  }
}
function ButtonIconComponent_button_0_Conditional_3_mat_icon_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "mat-icon", 2);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const icon_r5 = i0.ɵɵnextContext();
    i0.ɵɵproperty("fontSet", icon_r5.fontSet);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(icon_r5.icon);
  }
}
function ButtonIconComponent_button_0_Conditional_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonIconComponent_button_0_Conditional_3_mat_icon_0_Template, 2, 2, "mat-icon", 3);
  }
  if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("futGhostStateFragment", ctx_r1.state())("futGhostStateFragmentTextMaxChar", 2);
  }
}
function ButtonIconComponent_button_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵtemplate(1, ButtonIconComponent_button_0_Conditional_1_Template, 1, 2, "mat-icon", 2)(2, ButtonIconComponent_button_0_Conditional_2_Template, 2, 1)(3, ButtonIconComponent_button_0_Conditional_3_Template, 1, 2, "mat-icon", 2);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_8_0;
    let tmp_9_0;
    let tmp_10_0;
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction5(9, _c6, ctx_r1.variant() === "primary", ctx_r1.variant() === "secondary", ctx_r1.variant() === "tertiary", ctx_r1.variant() === "accent", ctx_r1.variant() === "link" || ctx_r1.variant() === "link-secondary"))("eventTitle", ctx_r1.eventTitle())("eventType", ctx_r1.eventType())("eventAction", ctx_r1.eventAction())("eventTarget", ctx_r1.eventTarget())("eventAttributes", ctx_r1.eventAttributesInternal());
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_8_0 = ctx_r1.internalLeftIcon()) ? 1 : -1, tmp_8_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_9_0 = ctx_r1.buttonTitle()) ? 2 : -1, tmp_9_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_10_0 = ctx_r1.internalRightIcon()) ? 3 : -1, tmp_10_0);
  }
}
function ButtonPodiumLabelComponent_div_3_Conditional_1_b_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const translate_r1 = i0.ɵɵnextContext().$implicit;
    const label_r2 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", translate_r1(label_r2.text, label_r2.translateArgs), " ");
  }
}
function ButtonPodiumLabelComponent_div_3_Conditional_1_b_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const label_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", label_r2.text, " ");
  }
}
function ButtonPodiumLabelComponent_div_3_Conditional_1_b_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "b", 4);
    i0.ɵɵtemplate(1, ButtonPodiumLabelComponent_div_3_Conditional_1_b_0_Conditional_1_Template, 1, 1)(2, ButtonPodiumLabelComponent_div_3_Conditional_1_b_0_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const label_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(label_r2.translate ? 1 : 2);
  }
}
function ButtonPodiumLabelComponent_div_3_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonPodiumLabelComponent_div_3_Conditional_1_b_0_Template, 3, 1, "b", 5);
  }
  if (rf & 2) {
    i0.ɵɵproperty("translocoScope", ctx.scope);
  }
}
function ButtonPodiumLabelComponent_div_3_Conditional_2_small_0_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const translate_r3 = i0.ɵɵnextContext().$implicit;
    const description_r4 = i0.ɵɵnextContext();
    i0.ɵɵtextInterpolate1(" ", translate_r3(description_r4.text, description_r4.translateArgs), " ");
  }
}
function ButtonPodiumLabelComponent_div_3_Conditional_2_small_0_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtext(0);
  }
  if (rf & 2) {
    const description_r4 = i0.ɵɵnextContext(2);
    i0.ɵɵtextInterpolate1(" ", description_r4.text, " ");
  }
}
function ButtonPodiumLabelComponent_div_3_Conditional_2_small_0_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "small", 4);
    i0.ɵɵtemplate(1, ButtonPodiumLabelComponent_div_3_Conditional_2_small_0_Conditional_1_Template, 1, 1)(2, ButtonPodiumLabelComponent_div_3_Conditional_2_small_0_Conditional_2_Template, 1, 1);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const description_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional(description_r4.translate ? 1 : 2);
  }
}
function ButtonPodiumLabelComponent_div_3_Conditional_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonPodiumLabelComponent_div_3_Conditional_2_small_0_Template, 3, 1, "small", 5);
  }
  if (rf & 2) {
    i0.ɵɵproperty("translocoScope", ctx.scope);
  }
}
function ButtonPodiumLabelComponent_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 3);
    i0.ɵɵtemplate(1, ButtonPodiumLabelComponent_div_3_Conditional_1_Template, 1, 1, "b", 4)(2, ButtonPodiumLabelComponent_div_3_Conditional_2_Template, 1, 1, "small", 4);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    let tmp_1_0;
    let tmp_2_0;
    const ctx_r4 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_1_0 = ctx_r4.translatedLabel()) ? 1 : -1, tmp_1_0);
    i0.ɵɵadvance();
    i0.ɵɵconditional((tmp_2_0 = ctx_r4.translatedDescription()) ? 2 : -1, tmp_2_0);
  }
}
const _forTrack0 = ($index, $item) => $item.id || $index;
function ButtonTileListComponent_For_1_Conditional_0_Template(rf, ctx) {
  if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fut-button-tile", 2);
    i0.ɵɵlistener("click", function ButtonTileListComponent_For_1_Conditional_0_Template_fut_button_tile_click_0_listener() {
      i0.ɵɵrestoreView(_r1);
      const button_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.buttonClicked(button_r2.id));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("state", ctx_r2.state())("secondaryIcon", button_r2.icon)("buttonTitle", button_r2.title)("ngClass", button_r2.variant);
  }
}
function ButtonTileListComponent_For_1_Conditional_1_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "fut-button-tile", 3);
    i0.ɵɵlistener("click", function ButtonTileListComponent_For_1_Conditional_1_Template_fut_button_tile_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const button_r2 = i0.ɵɵnextContext().$implicit;
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.buttonClicked(button_r2.id));
    });
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const button_r2 = i0.ɵɵnextContext().$implicit;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵproperty("state", ctx_r2.state())("imgSrc", button_r2.imgSrc)("buttonTitle", button_r2.title)("ngClass", button_r2.variant);
  }
}
function ButtonTileListComponent_For_1_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵtemplate(0, ButtonTileListComponent_For_1_Conditional_0_Template, 1, 4, "fut-button-tile", 0)(1, ButtonTileListComponent_For_1_Conditional_1_Template, 1, 4, "fut-button-tile", 1);
  }
  if (rf & 2) {
    const button_r2 = ctx.$implicit;
    i0.ɵɵconditional(button_r2.icon ? 0 : button_r2.imgSrc ? 1 : -1);
  }
}
let ActionIconComponent = /*#__PURE__*/(() => {
  class ActionIconComponent {
    constructor() {
      this.state = input();
      this.fontSet = input('material-symbols-outlined');
      this.hideBorder = input();
      this.tooltip = input();
      this.position = input('top');
      this.tooltipType = input('default');
      this.buttonType = input('default');
      this.size = input();
      this.eventTitle = input();
      this.eventAction = input();
      /**
       * if action is navigation: destination url,
       * if action is dialog: dialog title,
       * if action is download: file name,
       * if action is update: insert/edit/delete - for mix cases use 'insert, edit'
       */
      this.eventTarget = input();
      this.eventAttributes = input();
    }
    static {
      this.ɵfac = function ActionIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ActionIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ActionIconComponent,
        selectors: [["fut-action-icon"]],
        inputs: {
          state: [1, "state"],
          fontSet: [1, "fontSet"],
          hideBorder: [1, "hideBorder"],
          tooltip: [1, "tooltip"],
          position: [1, "position"],
          tooltipType: [1, "tooltipType"],
          buttonType: [1, "buttonType"],
          size: [1, "size"],
          eventTitle: [1, "eventTitle"],
          eventAction: [1, "eventAction"],
          eventTarget: [1, "eventTarget"],
          eventAttributes: [1, "eventAttributes"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 3,
        consts: [["iconContent", ""], ["futAnalyticsButton", "", "class", "fut-btn fut-btn-pill", 3, "eventTitle", "eventType", "eventAction", "eventTarget", "eventAttributes", "futTooltip", "hideTooltip", "ngClass", "position", "tooltipType", 4, "futGhostStateFragment", "futGhostStateFragmentTextMinChar", "futGhostStateFragmentTextMaxChar"], ["futAnalyticsButton", "", 1, "fut-btn", "fut-btn-pill", 3, "eventTitle", "eventType", "eventAction", "eventTarget", "eventAttributes", "futTooltip", "hideTooltip", "ngClass", "position", "tooltipType"], [4, "ngTemplateOutlet"], [1, "fut-text-opacity", 3, "fontSet"]],
        template: function ActionIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ActionIconComponent_button_0_Template, 3, 24, "button", 1)(1, ActionIconComponent_ng_template_1_Template, 2, 1, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
          }
          if (rf & 2) {
            i0.ɵɵproperty("futGhostStateFragment", ctx.state())("futGhostStateFragmentTextMinChar", 1)("futGhostStateFragmentTextMaxChar", 1);
          }
        },
        dependencies: [GhostStateFragmentDirective, TranslocoPipe, TooltipDirective, NgClass, NgTemplateOutlet, MatIcon, AnalyticsButtonDirective],
        styles: [".fut-btn[_ngcontent-%COMP%]:has(.fut-skeleton){border-color:transparent}.no-border[_ngcontent-%COMP%]{border:none;padding:0!important;height:fit-content!important;min-height:fit-content!important}.color-btn[_ngcontent-%COMP%], .secondary[_ngcontent-%COMP%], .tertiary[_ngcontent-%COMP%], .accent[_ngcontent-%COMP%]{border-width:0}.accent[_ngcontent-%COMP%]{background-color:var(--fut-accent-500)!important}.accent[_ngcontent-%COMP%]:hover{background-color:var(--fut-accent-600)!important}.tertiary[_ngcontent-%COMP%]{background-color:var(--fut-secondary-400)!important}.tertiary[_ngcontent-%COMP%]:hover{background-color:var(--fut-secondary-800)!important}.tertiary[_ngcontent-%COMP%]:hover   mat-icon[_ngcontent-%COMP%]{color:#fff!important;opacity:1}.secondary[_ngcontent-%COMP%]{background-color:var(--fut-secondary-800)!important}.secondary[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{color:#fff!important;opacity:1}.secondary[_ngcontent-%COMP%]:hover{background-color:var(--fut-secondary-400)!important}.secondary[_ngcontent-%COMP%]:hover   mat-icon[_ngcontent-%COMP%]{color:var(--fut-primary-500)!important}"]
      });
    }
  }
  return ActionIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonMenuContentComponent = /*#__PURE__*/(() => {
  class ButtonMenuContentComponent {
    constructor() {
      this.menuTitle = input();
      this.titleIcon = input();
    }
    static {
      this.ɵfac = function ButtonMenuContentComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonMenuContentComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonMenuContentComponent,
        selectors: [["fut-button-menu-content"]],
        inputs: {
          menuTitle: [1, "menuTitle"],
          titleIcon: [1, "titleIcon"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 3,
        vars: 1,
        consts: [[1, "menu-body"], [1, "d-flex", "align-items-center"], [1, "m-0", "fut-h3"]],
        template: function ButtonMenuContentComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵtemplate(1, ButtonMenuContentComponent_Conditional_1_Template, 4, 2, "header", 1);
            i0.ɵɵprojection(2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_0_0 = ctx.menuTitle()) ? 1 : -1, tmp_0_0);
          }
        },
        dependencies: [MatIcon],
        styles: [".menu-body[_ngcontent-%COMP%]{min-width:17.86em;margin:0 -1em}.menu-body[_ngcontent-%COMP%] > *[_ngcontent-%COMP%]{padding:0 1.43em}"]
      });
    }
  }
  return ButtonMenuContentComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonMenuElementComponent = /*#__PURE__*/(() => {
  class ButtonMenuElementComponent {
    constructor() {
      this.translocoService = inject(TranslocoService);
      this.iconInfo = input();
      this.iconPath = input();
      this.elementLabel = input();
      this.type = input('normal');
      this.eventAction = input();
      /**
       * if action is navigation: destination url,
       * if action is dialog: dialog title,
       * if action is download: file name,
       * if action is update: insert/edit/delete - for mix cases use 'insert, edit'
       */
      this.eventTarget = input();
      this.eventAttributes = input();
      this.label = computed(() => getTranslateModel(this.elementLabel()));
      this.icon = computed(() => {
        const iconInfo = this.iconInfo();
        if (!iconInfo) {
          return null;
        }
        if (typeof iconInfo !== 'string' && !iconInfo.icon) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
      this.eventTitle = computed(() => {
        const label = this.label();
        if (label) {
          if (!label.translate) {
            return of(label.text);
          }
          return this.translocoService.selectTranslate(label.text, label.translateArgs, label.scope ? {
            scope: label.scope
          } : undefined);
        }
        const icon = this.icon();
        if (icon) {
          return of(icon.icon);
        }
        return of(this.iconPath());
      });
      this.eventType = computed(() => {
        const label = this.label();
        if (label) {
          return 'text';
        }
        return 'icon';
      });
      this.buttonAttributes = computed(() => {
        const attributes = this.eventAttributes() || {};
        const label = this.label();
        const icon = this.icon()?.icon;
        const path = this.iconPath();
        if (label && icon) {
          attributes['icon'] = icon;
        }
        if ((label || icon) && path) {
          attributes['image'] = path;
        }
        return attributes;
      });
    }
    static {
      this.ɵfac = function ButtonMenuElementComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonMenuElementComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonMenuElementComponent,
        selectors: [["fut-button-menu-element"]],
        inputs: {
          iconInfo: [1, "iconInfo"],
          iconPath: [1, "iconPath"],
          elementLabel: [1, "elementLabel"],
          type: [1, "type"],
          eventAction: [1, "eventAction"],
          eventTarget: [1, "eventTarget"],
          eventAttributes: [1, "eventAttributes"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 5,
        vars: 13,
        consts: [["futAnalyticsButton", "", 1, "pointer", "d-flex", "align-items-center", "menu-element", 3, "eventTitle", "eventType", "eventAction", "eventTarget", "eventAttributes", "ngClass"], [3, "fontSet"], ["alt", "icon button", 3, "src"], [4, "transloco", "translocoScope"]],
        template: function ButtonMenuElementComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0);
            i0.ɵɵpipe(1, "async");
            i0.ɵɵtemplate(2, ButtonMenuElementComponent_Conditional_2_Template, 2, 2, "mat-icon", 1)(3, ButtonMenuElementComponent_Conditional_3_Template, 1, 1, "img", 2)(4, ButtonMenuElementComponent_Conditional_4_Template, 1, 1, "div");
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            let tmp_6_0;
            let tmp_7_0;
            let tmp_8_0;
            i0.ɵɵproperty("eventTitle", i0.ɵɵpipeBind1(1, 9, ctx.eventTitle()) || undefined)("eventType", ctx.eventType())("eventAction", ctx.eventAction())("eventTarget", ctx.eventTarget())("eventAttributes", ctx.buttonAttributes())("ngClass", i0.ɵɵpureFunction1(11, _c2, ctx.type() === "danger"));
            i0.ɵɵadvance(2);
            i0.ɵɵconditional((tmp_6_0 = ctx.icon()) ? 2 : -1, tmp_6_0);
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_7_0 = ctx.iconPath()) ? 3 : -1, tmp_7_0);
            i0.ɵɵadvance();
            i0.ɵɵconditional((tmp_8_0 = ctx.label()) ? 4 : -1, tmp_8_0);
          }
        },
        dependencies: [MatIcon, NgClass, TranslocoDirective, AnalyticsButtonDirective, AsyncPipe],
        styles: ["[_nghost-%COMP%]{display:block;--hover-background: var(--fut-secondary-50)}[_nghost-%COMP%]:hover{background-color:var(--hover-background)}[_nghost-%COMP%]:has(.type-danger){--hover-background: var(--fut-red-50);color:var(--fut-red-900)}.menu-element[_ngcontent-%COMP%]{line-height:1.43em;width:100%;min-height:3.77em;gap:1.03em;padding-left:1.47em}.menu-element[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%], .menu-element[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{font-size:24px;margin:.6em 0}.menu-element[_ngcontent-%COMP%]   .mat-icon[_ngcontent-%COMP%]{opacity:.7}.menu-element[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{font-size:24px}"]
      });
    }
  }
  return ButtonMenuElementComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonComboComponent = /*#__PURE__*/(() => {
  class ButtonComboComponent {
    constructor(ngControl) {
      this.ngControl = ngControl;
      this.urlParamsService = inject(UrlParamsService);
      this.state = input();
      this.items = input();
      this.buttonClasses = input('');
      this.fixedLabel = input();
      this.filterName = input();
      this.valueChange = output();
      this.menuOpened = signal(false);
      this.valueSelected = signal(undefined);
      this.labelSelected = computed(() => {
        const items = this.items();
        if (!items?.length) {
          return undefined;
        }
        const value = this.valueSelected();
        const label = items.find(item => item.value === value)?.label;
        if (!label) {
          return undefined;
        }
        return getTranslateModel(label);
      });
      this.labelFixed = computed(() => this.fixedLabel() ? getTranslateModel(this.fixedLabel()) : undefined);
      this.disabled = signal(false);
      this.initState = false;
      this.onChange = () => {};
      this.onTouch = () => {};
      if (this.ngControl != null) {
        this.ngControl.valueAccessor = this;
      }
      effect(() => {
        if (this.initState) {
          return;
        }
        const items = this.items();
        if (!items?.length) {
          return;
        }
        const filterName = this.filterName();
        if (!filterName) {
          return;
        }
        const filter = this.urlParamsService.getSnapshotFilter(filterName);
        if (!filter) {
          return;
        }
        const element = items.find(item => {
          const value = item.value;
          if (typeof value === 'object') {
            return JSON.stringify(value) === filter;
          }
          return value === filter;
        });
        if (!element) {
          return;
        }
        this.initState = true;
        if (this.valueSelected() === element) {
          return;
        }
        this.selectItem(element);
      }, {
        allowSignalWrites: true
      });
    }
    registerOnChange(fn) {
      this.onChange = fn;
    }
    registerOnTouched(fn) {
      this.onTouch = fn;
    }
    setDisabledState(isDisabled) {
      this.disabled.set(isDisabled);
    }
    writeValue(obj) {
      this.valueSelected.set(obj);
    }
    selectItem(item) {
      const value = item.value;
      this.onChange(value);
      this.valueSelected.set(value);
      this.valueChange.emit(value);
      const filterName = this.filterName();
      if (!filterName) {
        return;
      }
      let filterValue = null;
      if (typeof value === 'string') {
        filterValue = value;
      } else if (typeof value === 'object') {
        filterValue = JSON.stringify(value);
      }
      this.urlParamsService.setFilter(filterName, filterValue);
    }
    static {
      this.ɵfac = function ButtonComboComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonComboComponent)(i0.ɵɵdirectiveInject(i1.NgControl, 10));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonComboComponent,
        selectors: [["fut-button-combo"]],
        inputs: {
          state: [1, "state"],
          items: [1, "items"],
          buttonClasses: [1, "buttonClasses"],
          fixedLabel: [1, "fixedLabel"],
          filterName: [1, "filterName"]
        },
        outputs: {
          valueChange: "valueChange"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 1,
        consts: [["menu", "matMenu"], [1, "fut-btn", "btn-action-menu", 3, "menuOpened", "menuClosed", "ngClass", "matMenuTriggerFor"], [4, "futGhostStateFragment", "futGhostStateFragmentTextMinChar", "futGhostStateFragmentTextMaxChar"], ["matMenuContent", ""], [1, "fut-m-r-4"], ["fontSet", "material-symbols-outlined", 3, "ngClass"], ["class", "fut-m-r-4", 4, "transloco", "translocoScope"], [3, "elementLabel", "eventAction", "eventTarget", "eventAttributes", "iconInfo"], [3, "click", "elementLabel", "eventAction", "eventTarget", "eventAttributes", "iconInfo"]],
        template: function ButtonComboComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ButtonComboComponent_Conditional_0_Template, 5, 5);
          }
          if (rf & 2) {
            let tmp_0_0;
            i0.ɵɵconditional((tmp_0_0 = ctx.items()) ? 0 : -1, tmp_0_0);
          }
        },
        dependencies: [GhostStateFragmentDirective, NgClass, MatMenuTrigger, MatMenu, MatMenuContent, MatIcon, ButtonMenuElementComponent, ButtonMenuContentComponent, TranslocoDirective],
        styles: ["mat-icon[_ngcontent-%COMP%]{--rotate-deg: 0;transform:rotate(var(--rotate-deg));transition:all .15s ease-in-out}mat-icon.open[_ngcontent-%COMP%]{--rotate-deg: 180deg}"]
      });
    }
  }
  return ButtonComboComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonMenuComponent = /*#__PURE__*/(() => {
  class ButtonMenuComponent {
    constructor() {
      this.state = input();
      this.buttonIcon = input('more_vert');
      this.menuTitle = input();
      this.titleIcon = input();
      this.buttonType = input('default');
      this.size = input();
      this.tooltip = input();
      this.position = input('top');
      this.tooltipType = input('default');
    }
    onClick(event) {
      event.stopPropagation();
    }
    static {
      this.ɵfac = function ButtonMenuComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonMenuComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonMenuComponent,
        selectors: [["fut-button-menu"]],
        hostBindings: function ButtonMenuComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ButtonMenuComponent_click_HostBindingHandler($event) {
              return ctx.onClick($event);
            });
          }
        },
        inputs: {
          state: [1, "state"],
          buttonIcon: [1, "buttonIcon"],
          menuTitle: [1, "menuTitle"],
          titleIcon: [1, "titleIcon"],
          buttonType: [1, "buttonType"],
          size: [1, "size"],
          tooltip: [1, "tooltip"],
          position: [1, "position"],
          tooltipType: [1, "tooltipType"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 4,
        vars: 3,
        consts: [["menu", "matMenu"], ["class", "d-flex justify-content-center", 3, "matMenuTriggerFor", "position", "tooltipType", "tooltip", "hideBorder", "buttonType", "size", 4, "futGhostStateFragment", "futGhostStateFragmentTextMinChar", "futGhostStateFragmentTextMaxChar"], ["matMenuContent", ""], [1, "d-flex", "justify-content-center", 3, "matMenuTriggerFor", "position", "tooltipType", "tooltip", "hideBorder", "buttonType", "size"], [3, "menuTitle", "titleIcon"]],
        template: function ButtonMenuComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ButtonMenuComponent_fut_action_icon_0_Template, 2, 8, "fut-action-icon", 1);
            i0.ɵɵelementStart(1, "mat-menu", null, 0);
            i0.ɵɵtemplate(3, ButtonMenuComponent_ng_template_3_Template, 2, 2, "ng-template", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵproperty("futGhostStateFragment", ctx.state())("futGhostStateFragmentTextMinChar", 1)("futGhostStateFragmentTextMaxChar", 1);
          }
        },
        dependencies: [ButtonMenuContentComponent, ActionIconComponent, MatMenuTrigger, GhostStateFragmentDirective, MatMenu, MatMenuContent],
        styles: ["[_nghost-%COMP%]{display:contents}.ghost-menu[_ngcontent-%COMP%]{width:10px;border-radius:33%}"]
      });
    }
  }
  return ButtonMenuComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonTileComponent = /*#__PURE__*/(() => {
  class ButtonTileComponent {
    constructor(translate, analyticsService) {
      this.translate = translate;
      this.analyticsService = analyticsService;
      this.state = input(COMPONENT_STATE.NONE);
      this.variant = input('std');
      this.buttonTitle = input('');
      this.translateTitle = input(false);
      this.title = computed(() => this.textAndBooleanToModel(this.buttonTitle(), this.translateTitle()));
      this.buttonSubtitle = input('');
      this.translateSubtitle = input(false);
      this.subtitle = computed(() => this.textAndBooleanToModel(this.buttonSubtitle(), this.translateSubtitle()));
      this.primaryIcon = input('chevron_right');
      this.internalPrimaryIcon = computed(() => {
        const iconInfo = this.primaryIcon();
        if (!iconInfo) {
          return null;
        }
        if (typeof iconInfo !== 'string' && !iconInfo.icon) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
      this.secondaryIcon = input('');
      this.internalSecondaryIcon = computed(() => {
        const iconInfo = this.secondaryIcon();
        if (!iconInfo) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
      this.imgSrc = input();
      this.partial = input();
      this.total = input();
      this.eventAction = input();
      /**
       * if action is navigation: destination url,
       * if action is dialog: dialog title,
       * if action is download: file name,
       * if action is update: insert/edit/delete - for mix cases use 'insert, edit'
       */
      this.eventTarget = input();
    }
    onClick() {
      if (!this.analyticsService) {
        return;
      }
      const action = this.eventAction();
      const target = this.eventTarget();
      if (!action || !target) {
        return;
      }
      let number = this.partial()?.toString();
      if (this.total()) {
        number += `/${this.total()?.toString()}`;
      }
      const subtitle = this.getTranslatedText(this.subtitle());
      const icon_leading = this.internalSecondaryIcon()?.icon;
      const icon_trailing = this.internalPrimaryIcon()?.icon;
      const eventParams = {
        title: this.getTranslatedText(this.title()),
        type: 'tile',
        action,
        target
      };
      const attributesRecord = {};
      if (number != null) {
        attributesRecord['number'] = number;
      }
      if (subtitle) {
        attributesRecord['subtitle'] = subtitle;
      }
      if (icon_leading) {
        attributesRecord['icon_leading'] = icon_leading;
      }
      if (icon_trailing) {
        attributesRecord['icon_trailing'] = icon_trailing;
      }
      const attributes = makeAttributes(attributesRecord);
      if (attributes) {
        eventParams['attributes'] = attributes;
      }
      this.analyticsService.sendAnalytics({
        eventName: 'action_button_click',
        eventParams
      });
    }
    textAndBooleanToModel(text, translate) {
      if (!text) {
        return {
          text: ''
        };
      }
      if (typeof text === 'string') {
        return {
          text: text,
          translate: translate
        };
      }
      return text;
    }
    getTranslatedText(text) {
      if (!text.translate) {
        return text.text;
      }
      let label = text.text;
      if (text.scope) {
        label = `${text.scope}.${label}`;
      }
      return this.translate.translate(label, text.translateArgs);
    }
    static {
      this.ɵfac = function ButtonTileComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonTileComponent)(i0.ɵɵdirectiveInject(i1$1.TranslocoService), i0.ɵɵdirectiveInject(ANALYTICS_PROVIDER, 8));
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonTileComponent,
        selectors: [["fut-button-tile"]],
        hostBindings: function ButtonTileComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ButtonTileComponent_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
        },
        inputs: {
          state: [1, "state"],
          variant: [1, "variant"],
          buttonTitle: [1, "buttonTitle"],
          translateTitle: [1, "translateTitle"],
          buttonSubtitle: [1, "buttonSubtitle"],
          translateSubtitle: [1, "translateSubtitle"],
          primaryIcon: [1, "primaryIcon"],
          secondaryIcon: [1, "secondaryIcon"],
          imgSrc: [1, "imgSrc"],
          partial: [1, "partial"],
          total: [1, "total"],
          eventAction: [1, "eventAction"],
          eventTarget: [1, "eventTarget"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        ngContentSelectors: _c0,
        decls: 1,
        vars: 1,
        consts: [["class", "fut-button-tile", 3, "ngClass", 4, "transloco", "translocoScope"], [1, "fut-button-tile", 3, "ngClass"], [1, "d-flex", "flex-row", "align-items-center", "title-container", "fut-gap-8"], [1, "d-flex"], [1, "d-flex", "flex-column", "align-items-start", "w-100", "title-text"], [1, "d-flex", "flex-row", "align-items-baseline"], [1, "d-flex", "primary-icon"], [1, "title-icon", 3, "fontSet"], [1, "d-flex", "secondary-icon"], ["width", "24", "height", "24", "alt", "tile img", 1, "title-icon", 3, "src"], [1, "text-highlighted", "w-100", "title", "m-0"], ["class", "text-highlighted w-100 title m-0", 4, "futGhostStateFragment", "futGhostStateFragmentTextMinChar", "futGhostStateFragmentTextMaxChar"], [1, "title-wrap", 3, "futEditable"], [1, "title-wrap"], [3, "futEditable"], [1, "number-primary"], [1, "text-highlighted"], ["class", "title-icon", 3, "fontSet", 4, "futGhostStateFragment", "futGhostStateFragmentText"]],
        template: function ButtonTileComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵprojectionDef();
            i0.ɵɵtemplate(0, ButtonTileComponent_button_0_Template, 11, 14, "button", 0);
          }
          if (rf & 2) {
            i0.ɵɵproperty("translocoScope", ctx.title().scope);
          }
        },
        dependencies: [NgClass, MatIcon, GhostStateFragmentDirective, DecimalPipe, EditableDirective, TranslocoDirective],
        styles: [".fut-button-tile[_ngcontent-%COMP%]{--fut-button-title-color: var(--fut-primary-200);--background: var(--fut-button-title-bg, transparent);--background-color: var(--fut-button-title-bg-color, var(--fut-button-title-bg, transparent));--border-color: var(--fut-button-title-border, var(--fut-button-title-bg, transparent));width:100%;background:var(--background);background-color:var(--background-color);border:1px var(--fut-button-title-border-type, dashed) var(--border-color);padding:.71em 1.43em;border-radius:.8571428571em;color:var(--fut-button-title-color);transition:all .3s ease-in-out}.fut-button-tile.with-ghost[_ngcontent-%COMP%]{pointer-events:none}[disabled][_nghost-%COMP%]   .fut-button-tile[_ngcontent-%COMP%]:hover, .disabled[_nghost-%COMP%]   .fut-button-tile[_ngcontent-%COMP%]:hover{cursor:auto}.fut-button-tile[_ngcontent-%COMP%]   .text-highlighted[_ngcontent-%COMP%]{color:var(--fut-button-title-highlighted, var(--fut-button-title-color, var(--fut-primary-500)))}.fut-button-tile[_ngcontent-%COMP%]   .title-icon[_ngcontent-%COMP%]{color:var(--fut-button-title-icon-color, var(--fut-button-title-color, var(--fut-primary-300)))}.fut-button-tile[_ngcontent-%COMP%]:hover{--background: var(--fut-button-title-bg-hover, transparent);--background-color: var(--fut-button-title-bg-color-hover, var(--fut-button-title-bg-hover, transparent));--fut-button-title-border: var(--fut-button-title-bg-hover, transparent);--border-color: var(--fut-button-title-border)}.fut-button-tile[_ngcontent-%COMP%]:active{--background: var(--fut-button-title-bg-selected, var(--fut-button-title-bg-hover, transparent));--background-color: var(--fut-button-title-bg-color-selected, var(--fut-button-title-bg-hover, transparent));--fut-button-title-border: var(--fut-button-title-bg-selected, var(--fut-button-title-bg-hover, transparent));--border-color: var(--fut-button-title-border)}.fut-button-tile[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]{min-height:3em}.fut-button-tile[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]   .title-text[_ngcontent-%COMP%]{overflow:hidden}.fut-button-tile[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]   .title-text[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]{font-weight:700;text-align:left}.fut-button-tile[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]   .title-text[_ngcontent-%COMP%]   .title[_ngcontent-%COMP%]   .title-wrap[_ngcontent-%COMP%]{display:block;white-space:nowrap;text-overflow:ellipsis;overflow:hidden}.fut-button-tile[_ngcontent-%COMP%]   .title-container[_ngcontent-%COMP%]   .number-primary[_ngcontent-%COMP%]{font-size:23px;font-weight:700}.fut-button-tile.variant-std[_ngcontent-%COMP%]{--fut-button-title-bg: var(--fut-secondary-300);--fut-button-title-bg-hover: var(--fut-secondary-400);--fut-button-title-highlighted: var(--fut-primary-500)}[disabled][_nghost-%COMP%]   .fut-button-tile.variant-std[_ngcontent-%COMP%], .disabled[_nghost-%COMP%]   .fut-button-tile.variant-std[_ngcontent-%COMP%]{--fut-button-title-bg: var(--fut-gray-200);--fut-button-title-bg-hover: var(--fut-gray-200);--fut-button-title-color: var(--fut-gray-400)}.fut-button-tile.variant-light[_ngcontent-%COMP%]{--fut-button-title-bg: transparent;--fut-button-title-bg-hover: var(--fut-secondary-50);--fut-button-title-border: var(--fut-gray-200);--fut-button-title-highlighted: var(--fut-primary-500);--fut-button-title-border-type: solid}[disabled][_nghost-%COMP%]   .fut-button-tile.variant-light[_ngcontent-%COMP%], .disabled[_nghost-%COMP%]   .fut-button-tile.variant-light[_ngcontent-%COMP%]{--fut-button-title-bg-hover: transparent;--fut-button-title-border: var(--fut-gray-200);--fut-button-title-color: var(--fut-gray-400)}.fut-button-tile.variant-optional[_ngcontent-%COMP%]{--fut-button-title-bg: transparent;--fut-button-title-bg-hover: var(--fut-secondary-50);--fut-button-title-border: var(--fut-secondary-300);--fut-button-title-highlighted: var(--fut-primary-500)}[disabled][_nghost-%COMP%]   .fut-button-tile.variant-optional[_ngcontent-%COMP%], .disabled[_nghost-%COMP%]   .fut-button-tile.variant-optional[_ngcontent-%COMP%]{--fut-button-title-bg-hover: transparent;--fut-button-title-border: var(--fut-gray-200);--fut-button-title-color: var(--fut-gray-400)}.fut-button-tile.variant-dark[_ngcontent-%COMP%]{--fut-button-title-bg: linear-gradient(100deg, #1B213C 0%, #21418A 100%);--fut-button-title-bg-color: #1B213C;--fut-button-title-bg-hover: var(--fut-primary-A400);--fut-button-title-color: #FFFFFF;border-width:0;padding:calc(.71em + 3px) calc(1.43em + 3px)}[disabled][_nghost-%COMP%]   .fut-button-tile.variant-dark[_ngcontent-%COMP%], .disabled[_nghost-%COMP%]   .fut-button-tile.variant-dark[_ngcontent-%COMP%]{--fut-button-title-bg: var(--fut-gray-200);--fut-button-title-bg-color: var(--fut-gray-200);--fut-button-title-bg-hover: var(--fut-gray-200);--fut-button-title-color: var(--fut-gray-400)}"]
      });
    }
  }
  return ButtonTileComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonIconComponent = /*#__PURE__*/(() => {
  class ButtonIconComponent {
    constructor() {
      this.translocoService = inject(TranslocoService);
      this.state = input(COMPONENT_STATE.NONE);
      this.buttonTitle = input('');
      this.translateTitle = input(false);
      this.variant = input('primary');
      this.leftIcon = input('');
      this.internalLeftIcon = computed(() => {
        const iconInfo = this.leftIcon();
        if (!iconInfo) {
          return null;
        }
        if (typeof iconInfo !== 'string' && !iconInfo.icon) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
      this.rightIcon = input('');
      this.internalRightIcon = computed(() => {
        const iconInfo = this.rightIcon();
        if (!iconInfo) {
          return null;
        }
        if (typeof iconInfo !== 'string' && !iconInfo.icon) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
      this.eventType = input('text');
      this.eventAction = input();
      /**
       * if action is navigation: destination url,
       * if action is dialog: dialog title,
       * if action is download: file name,
       * if action is update: insert/edit/delete - for mix cases use 'insert, edit'
       */
      this.eventTarget = input();
      this.eventAttributes = input();
      this.eventTitle = computed(() => {
        if (!this.translateTitle()) {
          return this.buttonTitle();
        }
        return this.translocoService.translate(this.buttonTitle());
      });
      this.eventAttributesInternal = computed(() => {
        const attributes = this.eventAttributes() || {};
        const leftIcon = this.internalLeftIcon()?.icon;
        if (leftIcon) {
          attributes['left_icon'] = leftIcon;
        }
        const rightIcon = this.internalRightIcon()?.icon;
        if (rightIcon) {
          attributes['right_icon'] = rightIcon;
        }
        return attributes;
      });
    }
    static {
      this.ɵfac = function ButtonIconComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonIconComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonIconComponent,
        selectors: [["fut-button-icon"]],
        inputs: {
          state: [1, "state"],
          buttonTitle: [1, "buttonTitle"],
          translateTitle: [1, "translateTitle"],
          variant: [1, "variant"],
          leftIcon: [1, "leftIcon"],
          rightIcon: [1, "rightIcon"],
          eventType: [1, "eventType"],
          eventAction: [1, "eventAction"],
          eventTarget: [1, "eventTarget"],
          eventAttributes: [1, "eventAttributes"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 1,
        vars: 0,
        consts: [["class", "fut-btn fut-btn-icon fut-gap-2", "futAnalyticsButton", "", 3, "ngClass", "eventTitle", "eventType", "eventAction", "eventTarget", "eventAttributes", 4, "transloco"], ["futAnalyticsButton", "", 1, "fut-btn", "fut-btn-icon", "fut-gap-2", 3, "ngClass", "eventTitle", "eventType", "eventAction", "eventTarget", "eventAttributes"], [3, "fontSet"], [3, "fontSet", 4, "futGhostStateFragment", "futGhostStateFragmentTextMaxChar"], [1, "title-wrap", 3, "ngClass", "futEditable"], [1, "title-wrap", 3, "ngClass"], ["class", "title-wrap", 3, "ngClass", "futEditable", 4, "futGhostStateFragment", "futGhostStateFragmentTextMinChar", "futGhostStateFragmentTextMaxChar"], ["class", "title-wrap", 3, "ngClass", 4, "futGhostStateFragment", "futGhostStateFragmentTextMinChar", "futGhostStateFragmentTextMaxChar"]],
        template: function ButtonIconComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵtemplate(0, ButtonIconComponent_button_0_Template, 4, 15, "button", 0);
          }
        },
        dependencies: [MatIcon, TranslocoDirective, EditableDirective, NgClass, AnalyticsButtonDirective, GhostStateFragmentDirective],
        styles: [".fut-btn.fut-btn-icon[_ngcontent-%COMP%]   mat-icon[_ngcontent-%COMP%]{margin:0}"]
      });
    }
  }
  return ButtonIconComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonPodiumLabelComponent = /*#__PURE__*/(() => {
  class ButtonPodiumLabelComponent {
    constructor() {
      this.analyticsService = inject(ANALYTICS_PROVIDER, {
        optional: true
      });
      this.translate = inject(TranslocoService);
      this.state = input();
      this.icon = input.required();
      this.label = input.required();
      this.description = input();
      this.type = input('primary');
      this.dashed = input(false);
      this.eventAction = input();
      /**
       * if action is navigation: destination url,
       * if action is dialog: dialog title,
       * if action is download: file name,
       * if action is update: insert/edit/delete - for mix cases use 'insert, edit'
       */
      this.eventTarget = input();
      this.translatedLabel = computed(() => getTranslateModel(this.label()));
      this.translatedDescription = computed(() => getTranslateModel(this.description()));
      this.internalIcon = computed(() => {
        const iconInfo = this.icon();
        if (!iconInfo) {
          return null;
        }
        return getIconInfo(iconInfo);
      });
    }
    onClick() {
      if (!this.analyticsService) {
        return;
      }
      const action = this.eventAction();
      const target = this.eventTarget();
      if (!action || !target) {
        return;
      }
      const subtitle = this.getTranslatedText(this.translatedDescription());
      const icon = this.internalIcon()?.icon;
      const podiumType = this.type();
      const dashed = this.dashed() ? 'true' : undefined;
      const eventParams = {
        title: this.getTranslatedText(this.translatedLabel()),
        type: 'podium',
        action,
        target
      };
      const attributesRecord = {};
      if (icon) {
        attributesRecord['icon'] = icon;
      }
      if (subtitle) {
        attributesRecord['subtitle'] = subtitle;
      }
      if (podiumType) {
        attributesRecord['podium_type'] = podiumType;
      }
      if (dashed) {
        attributesRecord['dashed'] = dashed;
      }
      const attributes = makeAttributes(attributesRecord);
      if (attributes) {
        eventParams['attributes'] = attributes;
      }
      this.analyticsService.sendAnalytics({
        eventName: 'action_button_click',
        eventParams
      });
    }
    getTranslatedText(text) {
      if (!text.translate) {
        return text.text;
      }
      let label = text.text;
      if (text.scope) {
        label = `${text.scope}.${label}`;
      }
      return this.translate.translate(label, text.translateArgs);
    }
    static {
      this.ɵfac = function ButtonPodiumLabelComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonPodiumLabelComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonPodiumLabelComponent,
        selectors: [["fut-button-podium-label"]],
        hostBindings: function ButtonPodiumLabelComponent_HostBindings(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵlistener("click", function ButtonPodiumLabelComponent_click_HostBindingHandler() {
              return ctx.onClick();
            });
          }
        },
        inputs: {
          state: [1, "state"],
          icon: [1, "icon"],
          label: [1, "label"],
          description: [1, "description"],
          type: [1, "type"],
          dashed: [1, "dashed"],
          eventAction: [1, "eventAction"],
          eventTarget: [1, "eventTarget"]
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 4,
        vars: 7,
        consts: [[1, "d-flex", "align-items-center", "podium-label-container", "fut-gap-8", "pointer"], [3, "state", "icon", "type", "dashed"], ["class", "d-flex flex-column flex-grow-1 nowrap text-container", 4, "futGhostStateFragment", "futGhostStateFragmentTextMinChar", "futGhostStateFragmentTextMaxChar"], [1, "d-flex", "flex-column", "flex-grow-1", "nowrap", "text-container"], [1, "description"], ["class", "description", 4, "transloco", "translocoScope"]],
        template: function ButtonPodiumLabelComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "section", 0)(1, "div");
            i0.ɵɵelement(2, "fut-podium-icon", 1);
            i0.ɵɵelementEnd();
            i0.ɵɵtemplate(3, ButtonPodiumLabelComponent_div_3_Template, 3, 2, "div", 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("state", ctx.state())("icon", ctx.icon())("type", ctx.type())("dashed", ctx.dashed());
            i0.ɵɵadvance();
            i0.ɵɵproperty("futGhostStateFragment", ctx.state())("futGhostStateFragmentTextMinChar", 6)("futGhostStateFragmentTextMaxChar", 12);
          }
        },
        dependencies: [GhostStateFragmentDirective, PodiumIconComponent, TranslocoDirective],
        styles: [".podium-label-container[_ngcontent-%COMP%]{--hover-bg: var(--fut-secondary-50);padding:.8571428571em .5714285714em;border-radius:1em}.podium-label-container[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]{width:min(100% - 20em,100%)}.podium-label-container[_ngcontent-%COMP%]   .text-container[_ngcontent-%COMP%]   .description[_ngcontent-%COMP%]{overflow:hidden;text-overflow:ellipsis}.podium-label-container[_ngcontent-%COMP%]:hover{background-color:var(--hover-bg)}"]
      });
    }
  }
  return ButtonPodiumLabelComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let ButtonTileListComponent = /*#__PURE__*/(() => {
  class ButtonTileListComponent {
    constructor() {
      this.state = input(COMPONENT_STATE.NONE);
      this.buttons = input([]);
      this.buttonAction = output();
      this.castedButtons = computed(() => {
        if (this.state() !== COMPONENT_STATE.NONE) {
          return new Array(3).fill({
            icon: 'help'
          });
        }
        const buttons = this.buttons();
        return buttons;
      });
    }
    buttonClicked(id) {
      this.buttonAction.emit(id);
    }
    static {
      this.ɵfac = function ButtonTileListComponent_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || ButtonTileListComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: ButtonTileListComponent,
        selectors: [["fut-button-tile-list"]],
        inputs: {
          state: [1, "state"],
          buttons: [1, "buttons"]
        },
        outputs: {
          buttonAction: "buttonAction"
        },
        standalone: true,
        features: [i0.ɵɵStandaloneFeature],
        decls: 2,
        vars: 0,
        consts: [["variant", "light", 3, "state", "secondaryIcon", "buttonTitle", "ngClass"], ["variant", "light", 3, "state", "imgSrc", "buttonTitle", "ngClass"], ["variant", "light", 3, "click", "state", "secondaryIcon", "buttonTitle", "ngClass"], ["variant", "light", 3, "click", "state", "imgSrc", "buttonTitle", "ngClass"]],
        template: function ButtonTileListComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵrepeaterCreate(0, ButtonTileListComponent_For_1_Template, 2, 1, null, null, _forTrack0);
          }
          if (rf & 2) {
            i0.ɵɵrepeater(ctx.castedButtons());
          }
        },
        dependencies: [ButtonTileComponent, NgClass],
        styles: ["[_nghost-%COMP%]   fut-button-tile[_ngcontent-%COMP%]     .variant-light{--fut-button-title-border: transparent;padding:.5714285714em}[_nghost-%COMP%]   fut-button-tile.danger[_ngcontent-%COMP%]     .variant-light{--fut-button-title-color: var(--fut-red-900);--fut-button-title-highlighted: var(--fut-button-title-color)}"]
      });
    }
  }
  return ButtonTileListComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { ActionIconComponent, ButtonComboComponent, ButtonIconComponent, ButtonMenuComponent, ButtonMenuContentComponent, ButtonMenuElementComponent, ButtonPodiumLabelComponent, ButtonTileComponent, ButtonTileListComponent };
